import styled from 'styled-components'
import theme from 'styles/theme'
import { themeGet } from 'styled-system'
import { Container } from 'styles/sharedStyle'

export const ButtonPromoOuter = styled(Container)`
  position: relative;

  ${theme.mediaQueries.large} {
    padding: 0 ${theme.space[1]};
  }
`

export const ButtonPromoWrapper = styled.div`
  color: ${theme.colors.sagedark};
  width: 100%;
  display: block;
  background: ${(props) =>
    props.background === 'Grey'
      ? themeGet('colors.sagelight')
      : props.theme.backgroundColor};

  > div {
    display: flex;
    flex-direction: column;
    position: relative;
    margin: 0 auto;
    padding: 0 ${theme.space[3]};

    ${(props) =>
      props.inFooter
        ? `width: 100%; text-align: left;`
        : `width: 90%; text-align: center;`}

    ${theme.mediaQueries.medium} {
      padding: 0 ${theme.space[3]};
    }

    h2 {
      margin: 0;
    }

    button,
    a {
      margin: 0 auto;
      width: 100%;

      ${theme.mediaQueries.small} {
        width: auto;
      }
    }

    ${(props) =>
      props.inFooter
        ? `
      h2, p, button, a {
        font-family: ${props.theme.textStyles.fontPrimaryThin} ;
        text-align: left;
        margin-left: 0;
        display: block;
      }
      `
        : `
      max-width: 780px;
    `}
  }
`

export const BodyCopy = styled.div`
  color: ${(props) =>
    props.background === 'Gray' || props.background === 'Grey'
      ? props.theme.colors.slate
      : props.theme.colors.fontMainColor};
  text-align: inherit;
  ${(props) =>
    props.inFooter &&
    `p {font-family: ${props.theme.textStyles.fontRegularBody} !important; }`}
`
